import React from "react";
import "../styles/AboutConference.css";

const AboutConference = () => {
  return (
    <section id="about-conference" className="about-conference">
      <div className="container">
        <div className="about-content">
          <h2 className="section-title">About The Conference</h2>

          <div className="about-text">
            <p>
              Organised by the Department of Computer Science and Engineering,
              BIT Mesra, ICETTACS 2026 aims to foster innovation,
              interdisciplinary research, and global collaboration, contributing
              to impactful and sustainable technological advancements.
            </p>
            <p>
              The International Conference on Emerging Trends and Technologies
              in Applications of Computer Science (ICETTACS 2026) is a premier
              international forum that brings together researchers,
              academicians, industry professionals, and innovators to discuss
              recent advances and future directions in computer science and its
              real-world applications. The conference will be held on July 9–10,
              2026, at the Birla Institute of Technology (BIT), Mesra – Lalpur
              Unit, Ranchi.
            </p>

            <p>
              ICETTACS 2026 focuses on both theoretical foundations and applied
              innovations, addressing key challenges in today's rapidly evolving
              digital landscape. The conference covers emerging areas including
              cyber-physical systems, cybersecurity and blockchain, intelligent
              and responsible AI, mathematical and quantum computing, and
              computational approaches for sustainable development and earth
              resource exploration.
            </p>

            <p>
              The technical program is organised into five multidisciplinary
              tracks, encouraging cross-domain interaction and collaboration
              between academia and industry. ICETTACS 2026 will feature
              peer-reviewed paper presentations, keynote lectures by
              distinguished experts, and technical sessions, providing an
              excellent platform for knowledge exchange, research dissemination,
              and professional networking.
            </p>
          </div>

          <div className="highlights">
            <div className="highlight-item">
              <h4>🎯 Focus Areas</h4>
              <p>
                Cyber-physical systems, cybersecurity, AI, quantum computing,
                and sustainable development
              </p>
            </div>
            <div className="highlight-item">
              <h4>🌐 Global Platform</h4>
              <p>
                Brings together researchers, academicians, and industry
                professionals from around the world
              </p>
            </div>
            <div className="highlight-item">
              <h4>📋 5 Tracks</h4>
              <p>
                Multidisciplinary tracks encouraging cross-domain interaction
                and collaboration
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutConference;
